import { flexRender, Table } from '@tanstack/react-table'
import { Skeleton, Td, TRow } from '@tecsinapse/cortex-react'
import React from 'react'

interface BodyProps<T> {
  table: Table<T>
  onClickRow?: (row: T) => void
  onDoubleClickRow?: (row: T) => void
  id?: string
  loading?: boolean
}
const dummyArray = (size = 5) =>
  Array.from({ length: size }, (_, index) => ({ id: index }))

export const Body = <T,>({
  table,
  onClickRow,
  onDoubleClickRow,
  id,
  loading
}: BodyProps<T>) => {
  return (
    <tbody id={id}>
      {loading
        ? dummyArray(table.getState().pagination.pageSize).map((_, index) => (
            <TRow key={index}>
              <Td colSpan={99}>
                <Skeleton key={index} className='h-peta w-full rounded-mili' />
              </Td>
            </TRow>
          ))
        : table.getRowModel().rows.map(row => (
            <TRow
              key={row.id}
              onClick={() => onClickRow?.(row.original)}
              onDoubleClick={() => onDoubleClickRow?.(row.original)}
              className={
                onClickRow || onDoubleClickRow ? 'hover:cursor-pointer' : ''
              }
            >
              {row.getVisibleCells().map(cell => {
                return (
                  <Td
                    key={cell.id}
                    className={cell.column.getSize() === 20 ? 'p-0' : 'p-deca'}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </Td>
                )
              })}
            </TRow>
          ))}
    </tbody>
  )
}
